import { render, staticRenderFns } from "./MediaVerticalAlign.vue?vue&type=template&id=2e162900"
import script from "./MediaVerticalAlign.vue?vue&type=script&lang=js"
export * from "./MediaVerticalAlign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports